import React from 'react';

const primary = '#8d3939ff';

type PopUpMsgProps = {
	isOpen: boolean;
	title: string;
	description: string;
	onAccept: () => void;
	onClose: () => void;
	acceptLabel?: string;
	cancelLabel?: string;
};

const PopUpMsg: React.FC<PopUpMsgProps> = ({
	isOpen,
	title,
	description,
	onAccept,
	onClose,
	acceptLabel = 'Accept',
	cancelLabel = 'Cancel'
}) => {
	if (!isOpen) return null;

	return (
		<div style={{
			position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
			background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000
		}} role="dialog" aria-modal="true">
			<div style={{
				background: '#f9f9f9', width: 560, maxWidth: '96%', borderRadius: 12, display: 'flex', flexDirection: 'column',
				boxShadow: '0 14px 40px rgba(13,21,28,0.24)', overflow: 'hidden', fontFamily: 'Inter, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial'
			}}>
				<div style={{ padding: 20, borderBottom: '1px solid #f3f3f3' }}>
					<div style={{ fontSize: 18, fontWeight: 600, color: '#222' }}>{title}</div>
					<div style={{ marginTop: 8, color: '#555', fontSize: 14 }}>{description}</div>
				</div>

				<div style={{ padding: 16, display: 'flex', justifyContent: 'flex-end', gap: 12, background: '#fff' }}>
					<button onClick={onClose} style={{ background: 'transparent', color: '#666', border: '1px solid #e9e9e9', padding: '8px 12px', borderRadius: 8, cursor: 'pointer' }}>{cancelLabel}</button>
					<button onClick={onAccept} style={{ background: primary, color: '#fff', border: 'none', padding: '8px 14px', borderRadius: 8, cursor: 'pointer' }}>{acceptLabel}</button>
				</div>
			</div>
		</div>
	);
};

export default PopUpMsg;

